import { featureStateFor, FeatureSwitches } from './featureSwitches';
import { resolveFeature } from './resolveFeature';

export type FeatureAccount = {
  readonly id: number;
  readonly available_features?: readonly string[] | null;
  readonly admin_email?: string | null;
};

export function isFeatureOpenFor(account: FeatureAccount, switches: FeatureSwitches, flag: string): boolean {
  return resolveFeature(flag, {
    state: featureStateFor(switches, flag),
    email: account.admin_email,
    features: account.available_features,
    accountId: account.id,
  });
}
